import { Switch } from '@headlessui/react';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

type AnswersToggleProps = {
  isActive: boolean;
  onToggle: () => void;
};

function AnswersToggle({ isActive, onToggle }: AnswersToggleProps) {
  return (
    <div
      onClick={onToggle}
      className={`
        flex w-full cursor-pointer select-none items-center
        justify-between rounded-xl border px-3 py-2.5
        transition-all duration-200 sm:w-1/2
        ${
          isActive
            ? 'border-amber-400 bg-amber-100 shadow-sm'
            : 'border-zinc-200 bg-white hover:border-amber-200'
        }
      `}
    >
      <div className='flex items-center gap-2'>
        <span className={isActive ? 'text-amber-500' : 'text-zinc-400'}>
          {isActive ? <EyeIcon width={20} /> : <EyeSlashIcon width={20} />}
        </span>

        <div className='flex flex-col items-start'>
          <span className='text-[9px] font-bold uppercase text-zinc-400'>پاسخ‌ها:</span>

          <span className={`text-xs font-bold ${isActive ? 'text-amber-700' : 'text-zinc-500'}`}>
            {isActive ? 'نمایش' : 'مخفی'}
          </span>
        </div>
      </div>

      <Switch
        checked={isActive}
        className={`ltr relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
          isActive ? 'bg-amber-400' : 'bg-zinc-200'
        }`}
      >
        <span
          className={`block h-4 w-4 rounded-full bg-white transition-transform duration-200 ${
            isActive ? 'translate-x-1' : 'translate-x-6'
          }`}
        />
      </Switch>
    </div>
  );
}

export default AnswersToggle;
